/**
 * Created by james on 5/1/14.
 */
"use strict";

// ---------------------------------------------------
// Require Super PseudoClass

var SoaModel = require('bunsen/models/SoaModel');

// ---------------------------------------------------
// Define Module

/**
 * @class ServiceMethod
 * @extends SoaModel
 */
var ServiceMethod = module.exports = SoaModel.extend();

// ---------------------------------------------------
// Require Dependencies

var _ = require('underscore');
var endpoints = require('dibs-endpoints');
var DP = require('bunsen/helpers/dataProvider');
var serviceMethodDisplayDPConfig = require('bunsen/helpers/async-dp-configs/serviceMethodDisplay');
var Period = require('bunsen/models/Period');
var Region = require('bunsen/models/logistics/Region');
var Backbone = require('dibs-backbone');
var Seller = require('bunsen/models/Seller');
var SoaCollection = require('../../collections/SoaCollection');
var serviceMethodDisplay = require('dibs-static/admin/json/dealer/shipping/1/serviceMethodDisplay');
var globalCache = require('bunsen/helpers/globalCache');
var getDeferredMethods = require('bunsen/helpers/getDeferredMethods');

// Register the async data config
DP.addAsyncConfig(serviceMethodDisplayDPConfig);

// ---------------------------------------------------
// Local Vars

var deferred = getDeferredMethods().Deferred;
var displayInfoCacheKey = Symbol('fetching_seller_method_display_info');

// ---------------------------------------------------
// Define Module Static Properties

_.extend(ServiceMethod, {
    METHOD_STANDARD: 'STANDARD',
    METHOD_EXPRESS: 'EXPRESS',
    METHOD_MESSENGER: 'MESSENGER',
    METHOD_LOCAL_PICKUP: 'LOCAL_PICKUP',
    METHOD_FRONT_DOOR: 'FRONT_DOOR',
    SERVICE_WHITE_GLOVE: 'WHITE_GLOVE',
    SERVICE_FREIGHT: 'FREIGHT',
    SERVICE_PARCEL: 'PARCEL',

    /**
     * Returns a singleton collection that is
     * intended to be used to store display data for
     * the seller service methods.
     * @returns {SoaCollection}
     */
    getSellerMethodDisplayCollection: function () {
        if (!ServiceMethod._sellerMethodDisplayInfo) {
            ServiceMethod._sellerMethodDisplayInfo = new SoaCollection();
        }
        return ServiceMethod._sellerMethodDisplayInfo;
    },

    /**
     * Fetches the seller method display value reference sets from
     * the query service, unless they have already been fetched.
     * If they have already been fetched, returns the existing promise.
     * @returns {Deferred.promise}
     */
    fetchSellerMethodDisplayCollection: function () {
        var displayInfoProm = globalCache.get(displayInfoCacheKey);
        if (!displayInfoProm) {
            var self = this;
            displayInfoProm = deferred().resolve(serviceMethodDisplay).promise();
            globalCache.set(displayInfoCacheKey, displayInfoProm);
            displayInfoProm.done(function (json) {
                self.getSellerMethodDisplayCollection().reset(json);
            });
            displayInfoProm.fail(function () {
                globalCache.del(displayInfoCacheKey);
            });
        }
        return displayInfoProm;
    }

});


// ---------------------------------------------------
// Define Module Instance Properties

_.extend(ServiceMethod.prototype, {
    url: endpoints.shipmentServiceMethod(),
    relations: SoaModel.createRelations([
        {
            type : Backbone.One,
            key : 'windowMax',
            relatedModel : Period
        },
        {
            type : Backbone.One,
            key : 'windowMin',
            relatedModel : Period
        },
        {
            type : Backbone.One,
            key : 'region',
            relatedModel : Region
        },
        {
            type : Backbone.One,
            key : 'windowMinLimit',
            relatedModel : Period
        },
        {
            type : Backbone.One,
            key : 'windowMaxLimit',
            relatedModel : Period
        }
    ]),

    /**
     * @returns {boolean}
     */
    isWhiteGlove: function () {
        return ServiceMethod.SERVICE_WHITE_GLOVE === this.get("serviceType");
    },

    /**
     * @returns {boolean}
     */
    isFrontDoor: function () {
        return ServiceMethod.METHOD_FRONT_DOOR === this.get("serviceMethodType");
    },

    /**
     * @returns {string}
     */
    getShipmentType: function () {
        var serviceMethodType = this.get('serviceMethodType');
        switch (serviceMethodType) {
            case 'LOCAL_PICKUP':
            case 'TYPE_EXTERNALLY_ARRANGED':
                return serviceMethodType;
            default:
                return 'FIRSTDIBS_FACILITATED';
        }
    },

    /**
     * @returns {boolean}
     */
    isLocalPickup: function () {
        return ServiceMethod.METHOD_LOCAL_PICKUP === this.get("serviceMethodType");
    },

    /**
     * @returns {boolean}
     */
    isParcel: function () {
        return ServiceMethod.SERVICE_PARCEL === this.get('serviceType');
    },

    /**
     * Retrieves the display value for service method
     * serviceMethodType/serviceType combinations that
     * are intended for sellers.
     * @param {string} [vertical]
     *      One of 'furniture', 'art', 'fashion', or
     *      'jewelry'. Defaults to current seller
     *      vertical.
     * @param {string} [serviceMethodType]
     *      Enum string val for serviceMethodType.
     *      Defaults to model's serviceMethodType
     * @param {string} [serviceType]
     *      Enum string val for serviceType. Defaults
     *      to the model's serviceType value.
     * @returns {string}
     */
    getSellerMethodDisplayVal: function (vertical, serviceMethodType, serviceType) {

        serviceMethodType = serviceMethodType || this.get('serviceMethodType');
        serviceType = serviceType || this.get('serviceType');

        var sellerDisplayReferences = ServiceMethod.getSellerMethodDisplayCollection();
        var i = 0;
        var referenceModel;
        var seller;

        if (!vertical) {
            seller = Seller.getCurrentSeller();
            vertical = seller ? seller.get('vertical') : null;
            if (!vertical) {
                return null;
            }
        }

        for (i; i < sellerDisplayReferences.length; i++) {
            referenceModel = sellerDisplayReferences.at(i);
            if (referenceModel.get('serviceType') === serviceType &&
                    referenceModel.get('serviceMethodType') === serviceMethodType &&
                    _.indexOf(referenceModel.get('verticals'), vertical) > -1) {
                return referenceModel.get('displayName');
            }
        }
        return null;
    }
});



// WEBPACK FOOTER //
// ./~/bunsen/models/logistics/ServiceMethod.es.js